import agency from './agency.json'
import common from './common.json'
import dataTable from './data-table.json'
import errors from './errors.json'
import requests from './requests.json'
import sidebar from './sidebar.json'
import translations from './translations.json'

export default {
  translations,
  common,
  requests,
  agency,
  sidebar,
  errors,
  'data-table': dataTable,
}
